<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <router-link :to="{ name: 'DashboardMain'}" class="mx-6 my-2">
        <v-img class="" src="../../public/img/wertheim-logo.svg" height="50" contain></v-img>
    </router-link>
      <v-list dense align="left" class="pa-0">
        <MenuItem>
        </MenuItem>
        <v-divider></v-divider>
<!--        <div v-if="isAdmin()">-->
<!--          <v-divider></v-divider>-->
<!--          <div class="admin-area mt-4">-->
<!--&lt;!&ndash;            <div class="body-2 mx-4 font-weight-bold">&ndash;&gt;-->
<!--&lt;!&ndash;              {{ $t("adminSettingsLabels") }}&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <v-list-item class="mt-2" :color="!item.disabled ? 'primary' : ''" :to="item.link"-->
<!--              v-for="(item, index) in items" :key="index" link>-->
<!--              <v-list-item-action>-->
<!--                <v-icon>{{ item.icon }}</v-icon>-->
<!--              </v-list-item-action>-->
<!--              <v-list-item-content>-->
<!--                <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>-->
<!--              </v-list-item-content>-->
<!--            </v-list-item>-->
<!--          </div>-->
<!--        </div>-->
        <div>
<!--          <v-divider></v-divider>-->
<!--          <div class="mt-4">-->
<!--            <div class="body-2 mx-4 font-weight-bold">-->
<!--              {{ $t('settingsLabel')}}-->
<!--            </div>-->
<!--          </div>-->
          <v-list-item v-for="(item, index) in settingsMenu.filter(f => f.restrict)" :key="index" link :to="item.link">
            <v-list-item-action>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t(item.text) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app class="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t("dashboardLabel") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <div class="notifications-holder" style="position: relative">
        <v-btn icon class="mr-4" @click="toggleNotifications = !toggleNotifications">
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn>
        <div v-if="toggleNotifications" class="notifications-panel">
          <div class="h4 font-weight-bold my-6 text-center">
            {{ $t("notificationsLabel") }}
          </div>
          <ul class="notifications-list">
            <li>
              <a href="javascript:void(0)" class="notification-item">
                <div class="body-2 mb-2 text-left">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quo
                  eius ad quas in quis repellendus?
                </div>
                <div class="body-2 text-left primary--text">
                  12/08/2020 - 14:44:21
                </div>
              </a>
            </li>
            <v-divider style="border-color: rgb(218 218 218)"></v-divider>
            <li>
              <a href="javascript:void(0)" class="notification-item">
                <div class="body-2 mb-2 text-left">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quo
                  eius ad quas in quis repellendus?
                </div>
                <div class="body-2 text-left primary--text">
                  12/08/2020 - 14:44:21
                </div>
              </a>
            </li>
            <v-divider style="border-color: rgb(218 218 218)"></v-divider>
            <li>
              <a href="javascript:void(0)" class="notification-item">
                <div class="body-2 mb-2 text-left">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quo
                  eius ad quas in quis repellendus?
                </div>
                <div class="body-2 text-left primary--text">
                  12/08/2020 - 14:44:21
                </div>
              </a>
            </li>
            <v-divider style="border-color: rgb(218 218 218)"></v-divider>
            <li>
              <a href="javascript:void(0)" class="notification-item">
                <div class="body-2 mb-2 text-left">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quo
                  eius ad quas in quis repellendus?
                </div>
                <div class="body-2 text-left primary--text">
                  12/08/2020 - 14:44:21
                </div>
              </a>
            </li>
            <v-divider style="border-color: rgb(218 218 218)"></v-divider>
            <li>
              <a href="javascript:void(0)" class="notification-item">
                <div class="body-2 mb-2 text-left">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quo
                  eius ad quas in quis repellendus?
                </div>
                <div class="body-2 text-left primary--text">
                  12/08/2020 - 14:44:21
                </div>
              </a>
            </li>
            <v-divider style="border-color: rgb(218 218 218)"></v-divider>
            <li>
              <a href="javascript:void(0)" class="notification-item">
                <div class="body-2 mb-2 text-left">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quo
                  eius ad quas in quis repellendus?
                </div>
                <div class="body-2 text-left primary--text">
                  12/08/2020 - 14:44:21
                </div>
              </a>
            </li>
            <v-divider style="border-color: rgb(218 218 218)"></v-divider>
            <li>
              <a href="javascript:void(0)" class="notification-item">
                <div class="body-2 mb-2 text-left">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quo
                  eius ad quas in quis repellendus?
                </div>
                <div class="body-2 text-left primary--text">
                  12/08/2020 - 14:44:21
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div> -->

      <v-chip class="ma-2" color="primary" label @click="logout">
        <v-icon left>mdi-logout</v-icon>
        {{ $t("logoutLabel") }}
      </v-chip>
    </v-app-bar>

    <v-main class="dashboard-background">
      <template v-if="$route.name == 'DashboardMain'"></template>
      <template v-else>
        <v-btn class="mt-4 ml-10" text @click="goBackButton()">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t("backLabel") }}
        </v-btn>
      </template>


      <v-container class="" fluid>
        <v-row align="start" justify="center" height="100%">
          <template v-if="this.$route.name == 'DashboardMain'">
            <router-view></router-view>
          </template>
          <template v-else-if="this.$route.name == 'Profile'">
            <v-card class="pa-10 rounded-xl ma-10 mt-0 mr-auto" elevation="3" height="100%" min-height="500px" width="50%">
              <v-overlay absolute color="white" opacity="1" :value="loading">
                <v-progress-circular :size="100" color="primary" indeterminate></v-progress-circular>
              </v-overlay>
              <router-view></router-view>
            </v-card>
          </template>
          <v-card v-else class="pa-10 rounded-xl ma-10 mt-0" elevation="3" height="100%" min-height="400px" width="100%">
            <v-overlay absolute color="white" opacity="1" :value="loading">
              <v-progress-circular :size="100" color="primary" indeterminate></v-progress-circular>
            </v-overlay>
            <router-view></router-view>
          </v-card>
        </v-row>
      </v-container>
    </v-main>
    <v-dialog
      :close-delay="3000"
      v-model="snackbar.show"
      max-width="360"
      overlay-opacity="0.3"
    >
      <v-card>
        <div class="pa-4 pb-0">
          <div class="subtitle-1 text-center" v-text="snackbar.message"></div>
        </div>
        <v-card-actions>
          <v-btn
            small
            class="mx-auto"
            color="primary"
            @click="snackbar.show = false"
          >
            {{$t('closeLabel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import MenuItem from "@/components/MenuItems.vue";
  import UserTypes from "../auth/userTypes";

  export default {
    data(){
      return{
        loading: false,
        snackbar: {
          color: "success",
          timeout: 3000,
          show: false,
          message: "",
        },
        toggleNotifications: false,
        drawer: null,
        // items: [{
        //   icon: "mdi-label-multiple",
        //   text: "labelsLabel",
        //   link: "/dashboard/labels",
        // },
        //   {
        //     icon: "mdi-translate",
        //     text: "configureTranslationsLabel",
        //     link: "/dashboard/config-translations",
        //   },
        // ],
        settingsMenu: [
          {
            icon: "mdi-account-circle-outline",
            text: "profileLabel",
            link: "/dashboard/profile",
            restrict: true
          },
          {
            icon: "mdi-handshake",
            text: "salesPartnershipsLabel",
            link: "/dashboard/sale-partnerships",
            restrict: this.canAccessSalesPartnership()
          },
          {
            icon: "mdi-translate",
            text: "configureTranslationsLabel",
            link: "/dashboard/config-translations",
            restrict: this.isAdmin()
          },
          {
            icon: "mdi-label-multiple",
            text: "labelsLabel",
            link: "/dashboard/labels",
            restrict: this.isAdmin()
          },
          {
            icon: "mdi-domain",
            text: "affiliatePartnershipSalesLabel",
            link: "/dashboard/affiliate-partnership-sales",
            restrict: this.canAccessSAP()
          },
          {
            icon: "mdi-account-cog-outline",
            text: "salesPartnershipUsersLabel",
            link: "/dashboard/sale-partnership-users",
            restrict: this.canAccessSAP()
          },
          {
            icon: "mdi-tag-plus-outline",
            text: "pricingConditionsLabel",
            link: "/dashboard/settings/pricing",
            restrict: this.canAccessPricingPage()
          },
          {
            icon: "mdi-sitemap",
            text: "materialMappingLabel",
            link: "/dashboard/settings/mapping",
            restrict: true
          }
        ]
      }
    },
    methods: {
      isAdmin() {
        if (this.$store.getters.getUserType == UserTypes.WertheimAdministrator) {
          return true
        }
        return false
      },
      snackbarEventHandler(snackbar) {
        this.snackbar.show = snackbar.show;
        this.snackbar.message = snackbar.message;
      },
      logout() {
        this.$store.dispatch("logout");
        this.$auth.destroyToken();
        this.$router.push({
          name: "Login",
        });
      },
      loadingHandler(loading) {
        this.loading = loading;
      },
      goBackButton() {
        let prevUrl = this.$store.getters.getPrevRoute.substring(0,21).substring(1);
        if(prevUrl === 'product-configurator') {
          this.$router.go(-3);
        }else {
          this.$router.go(-1);
        }
      },
      canAccessPricingPage() {
        let userType = parseInt(this.$store.state.user.userType);
        return userType === UserTypes.WertheimSales ||
                userType === UserTypes.WertheimAdministrator ||
                userType === UserTypes.SalesPartnershipAdmin;
      },
      canAccessSalesPartnership(){
        let userType = parseInt(this.$store.state.user.userType);
        return userType === UserTypes.WertheimSales ||
            userType === UserTypes.WertheimAdministrator
      },
      canAccessSAP(){
        let userType = parseInt(this.$store.state.user.userType);
        return userType === UserTypes.SalesPartnershipAdmin
      }
    },
    components: {
      MenuItem,
    },
    mounted() {
      this.$EventBus.$on("snackbar", this.snackbarEventHandler);
      this.$EventBus.$on("loading", this.loadingHandler)
    },
  };
</script>

<style lang="scss">
  .dashboard-background {
    background: #eaeaea;
  }
</style>